import LegalLayout, { LegalFooter } from "../layouts/LegalLayout";

const styles = {
  wrapper: {
    minHeight: "100vh",
    background: "#f4f7fe",
    fontFamily: "Arial, sans-serif",
  },
  navbar: {
    background: "#fff",
    padding: "14px 32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
    position: "sticky",
    top: 0,
    zIndex: 100,
  },
  navLogo: {
    fontSize: 20,
    fontWeight: 800,
    color: "#4318FF",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  navLinks: {
    display: "flex",
    alignItems: "center",
    gap: 24,
    listStyle: "none",
    margin: 0,
    padding: 0,
  },
  navLink: {
    color: "#374151",
    textDecoration: "none",
    fontSize: 14,
    fontWeight: 500,
  },
  navLoginBtn: {
    background: "#4318FF",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    padding: "8px 20px",
    fontSize: 14,
    fontWeight: 700,
    cursor: "pointer",
    textDecoration: "none",
  },
  hero: {
    background: "linear-gradient(135deg, #4318FF, #7551FF)",
    color: "#fff",
    padding: "60px 20px",
    textAlign: "center",
  },
  heroTitle: {
    fontSize: 36,
    fontWeight: 800,
    margin: "0 0 12px 0",
  },
  heroMeta: {
    fontSize: 14,
    opacity: 0.85,
    margin: 0,
  },
  content: {
    maxWidth: 800,
    margin: "0 auto",
    padding: "40px 20px",
  },
  tocCard: {
    background: "#fff",
    borderRadius: 16,
    padding: "24px 28px",
    marginBottom: 20,
    boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
    borderLeft: "4px solid #4318FF",
  },
  tocHeading: {
    fontSize: 15,
    fontWeight: 800,
    color: "#1b2559",
    marginBottom: 12,
    marginTop: 0,
  },
  tocList: {
    listStyle: "none",
    padding: 0,
    margin: 0,
    display: "flex",
    flexWrap: "wrap",
    gap: "6px 24px",
  },
  tocItem: {
    fontSize: 13,
    color: "#4318FF",
    textDecoration: "none",
    fontWeight: 600,
    lineHeight: 1.8,
  },
  card: {
    background: "#fff",
    borderRadius: 16,
    padding: "24px 28px",
    marginBottom: 20,
    boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
  },
  sectionHeading: {
    fontSize: 17,
    fontWeight: 800,
    color: "#1b2559",
    marginBottom: 12,
    marginTop: 0,
  },
  bodyText: {
    fontSize: 14,
    color: "#374151",
    lineHeight: 2,
    margin: 0,
  },
  subHeading: {
    fontSize: 14,
    fontWeight: 700,
    color: "#1b2559",
    marginTop: 16,
    marginBottom: 6,
  },
  infoBox: {
    background: "#f0f4ff",
    border: "1px solid #c7d2fe",
    borderRadius: 8,
    padding: "12px 16px",
    fontSize: 13,
    color: "#3730a3",
    lineHeight: 1.7,
    marginTop: 12,
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: 12,
    fontSize: 13,
  },
  th: {
    background: "#f4f7fe",
    color: "#1b2559",
    fontWeight: 700,
    padding: "10px 12px",
    textAlign: "left",
    border: "1px solid #e5e7eb",
  },
  td: {
    padding: "10px 12px",
    border: "1px solid #e5e7eb",
    color: "#374151",
    lineHeight: 1.7,
    verticalAlign: "top",
  },
  footer: {
    background: "#1b2559",
    color: "#fff",
    padding: "30px 20px",
    textAlign: "center",
  },
  footerLinks: {
    display: "flex",
    justifyContent: "center",
    gap: 24,
    marginBottom: 16,
    flexWrap: "wrap",
  },
  footerLink: {
    color: "#a0aec0",
    textDecoration: "none",
    fontSize: 13,
  },
  footerText: {
    fontSize: 13,
    color: "#a0aec0",
    margin: "4px 0",
  },
};

const PrivacyPolicy = () => {
  return (
    <LegalLayout activePage="privacy">

      {/* Hero */}
      <div style={styles.hero}>
        <h1 style={styles.heroTitle}>Privacy Policy</h1>
        <p style={styles.heroMeta}>Effective Date: 1st January 2025 &nbsp;|&nbsp; Last Updated: 28th March 2026</p>
      </div>

      {/* Content */}
      <div style={styles.content}>

        {/* Intro */}
        <div style={{ ...styles.card, borderLeft: "4px solid #4318FF" }}>
          <p style={styles.bodyText}>
            <strong>Uvars OPC Private Limited</strong>, operating as FraudCheck FDS ("We", "Us", "Our", "Platform"), is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and protect your personal information when you use our platform at <strong>fds.uvars.com</strong>.
          </p>
          <p style={{ ...styles.bodyText, marginTop: 10 }}>
            This Privacy Policy is published in compliance with the <strong>Information Technology Act, 2000</strong> and the <strong>Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011</strong> ("SPDI Rules"). By using our Platform, you consent to the practices described in this policy.
          </p>
        </div>

        {/* Table of Contents */}
        <div style={styles.tocCard}>
          <p style={styles.tocHeading}>Table of Contents</p>
          <ul style={styles.tocList}>
            {[
              ["#collect", "1. What We Collect"],
              ["#use", "2. How We Use It"],
              ["#sharing", "3. Data Sharing"],
              ["#security", "4. Data Security"],
              ["#cookies", "5. Cookies"],
              ["#rights", "6. Your Rights Under Indian Law"],
              ["#retention", "7. Data Retention"],
              ["#children", "8. Children's Privacy"],
              ["#grievance", "9. Grievance Officer"],
              ["#changes", "10. Changes to This Policy"],
              ["#contact", "11. Contact Us"],
            ].map(([href, label]) => (
              <li key={href}><a href={href} style={styles.tocItem}>{label}</a></li>
            ))}
          </ul>
        </div>

        {/* 1. What We Collect */}
        <div style={styles.card} id="collect">
          <h2 style={styles.sectionHeading}>1. Information We Collect</h2>
          <p style={styles.bodyText}>
            We collect the following categories of information when you register and use FraudCheck FDS:
          </p>

          <p style={styles.subHeading}>1.1 Account & Identity Information</p>
          <ul style={{ ...styles.bodyText, paddingLeft: 20, marginTop: 6 }}>
            <li style={{ marginBottom: 6 }}><strong>Full Name</strong> — used for account identification and correspondence.</li>
            <li style={{ marginBottom: 6 }}><strong>Email Address</strong> — used for login, notifications, and communication.</li>
            <li style={{ marginBottom: 6 }}><strong>Phone Number</strong> — used for account verification and contact.</li>
            <li style={{ marginBottom: 6 }}><strong>Company / Business Name</strong> — used to identify your rental business on the Platform.</li>
            <li style={{ marginBottom: 6 }}><strong>Location (State, District, City)</strong> — used for regional fraud intelligence and search filtering.</li>
            <li style={{ marginBottom: 6 }}><strong>Password</strong> — stored in encrypted (hashed) form; we never store plaintext passwords.</li>
          </ul>

          <p style={styles.subHeading}>1.2 Payment Information</p>
          <p style={styles.bodyText}>
            We collect subscription payment details to process your plan activation. Payment transactions are processed through secure payment infrastructure. We do not store full card or UPI credentials on our servers — payment is handled by our payment gateway partner. We store subscription status, plan name, amount, payment date, and transaction reference for record-keeping and customer support.
          </p>

          <p style={styles.subHeading}>1.3 Fraud Reports You Submit</p>
          <p style={styles.bodyText}>
            When you file a fraud report, you provide third-party customer data including:
          </p>
          <ul style={{ ...styles.bodyText, paddingLeft: 20, marginTop: 6 }}>
            <li style={{ marginBottom: 6 }}>Customer name, phone number, Aadhaar number, or Driving Licence number</li>
            <li style={{ marginBottom: 6 }}>Incident description and fraud type</li>
            <li style={{ marginBottom: 6 }}>Photographs (uploaded securely via Cloudinary)</li>
            <li style={{ marginBottom: 6 }}>Date, location, and circumstances of the incident</li>
          </ul>
          <div style={styles.infoBox}>
            You are responsible for ensuring you have a lawful basis for submitting third-party personal data. By submitting a report, you represent that the information is accurate to the best of your knowledge and was collected in compliance with applicable law.
          </div>

          <p style={styles.subHeading}>1.4 Technical & Usage Data</p>
          <ul style={{ ...styles.bodyText, paddingLeft: 20, marginTop: 6 }}>
            <li style={{ marginBottom: 6 }}>IP address, browser type, and device information</li>
            <li style={{ marginBottom: 6 }}>Pages visited, features used, and time spent on the Platform</li>
            <li style={{ marginBottom: 6 }}>Activity logs (login times, actions performed)</li>
          </ul>
        </div>

        {/* 2. How We Use It */}
        <div style={styles.card} id="use">
          <h2 style={styles.sectionHeading}>2. How We Use Your Information</h2>
          <p style={styles.bodyText}>We use the information we collect for the following purposes:</p>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>Purpose</th>
                <th style={styles.th}>Data Used</th>
              </tr>
            </thead>
            <tbody>
              {[
                ["Account creation and authentication", "Name, email, phone, password"],
                ["Providing and operating the Platform", "All account and usage data"],
                ["Processing subscription payments", "Payment info, plan details"],
                ["Displaying and enabling fraud search", "Fraud report content"],
                ["Sending notifications and alerts", "Email, phone, notification preferences"],
                ["Customer support and grievance resolution", "Account info, communication records"],
                ["Platform security and fraud prevention", "IP address, activity logs, usage data"],
                ["Analytics and platform improvement", "Aggregated and anonymized usage data"],
                ["Legal compliance and enforcement", "All categories as required by law"],
              ].map(([purpose, data], i) => (
                <tr key={i}>
                  <td style={styles.td}>{purpose}</td>
                  <td style={styles.td}>{data}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* 3. Data Sharing */}
        <div style={styles.card} id="sharing">
          <h2 style={styles.sectionHeading}>3. Data Sharing</h2>
          <p style={styles.bodyText}>
            <strong>We do not sell, rent, or trade your personal data to any third party for commercial purposes.</strong> Your data is never used for advertising or sold to data brokers.
          </p>
          <p style={{ ...styles.bodyText, marginTop: 12 }}>We may share data only in the following limited circumstances:</p>

          <p style={styles.subHeading}>3.1 With Other Platform Users (Fraud Reports)</p>
          <p style={styles.bodyText}>
            Fraud report data — which includes information about reported customers — is shared with other verified rental owners on the Platform for the purpose of fraud prevention. This is the core function of FraudCheck FDS and is disclosed to all users at registration.
          </p>

          <p style={styles.subHeading}>3.2 With Service Providers</p>
          <p style={styles.bodyText}>
            We use trusted third-party service providers who assist us in operating the Platform, including:
          </p>
          <ul style={{ ...styles.bodyText, paddingLeft: 20, marginTop: 6 }}>
            <li style={{ marginBottom: 6 }}><strong>Cloudinary</strong> — for secure image hosting and storage of uploaded fraud evidence photographs</li>
            <li style={{ marginBottom: 6 }}><strong>MongoDB Atlas</strong> — for secure cloud database storage</li>
            <li style={{ marginBottom: 6 }}>Payment gateway providers for processing subscription payments</li>
          </ul>
          <p style={{ ...styles.bodyText, marginTop: 10 }}>
            These providers are contractually required to maintain confidentiality and use your data only for the specified purpose.
          </p>

          <p style={styles.subHeading}>3.3 Legal Requirements</p>
          <p style={styles.bodyText}>
            We may disclose your information if required to do so by law, court order, or lawful authority of the Government of India, or if we believe disclosure is necessary to protect our rights, prevent fraud, or protect the safety of users or the public.
          </p>
        </div>

        {/* 4. Data Security */}
        <div style={styles.card} id="security">
          <h2 style={styles.sectionHeading}>4. Data Security</h2>
          <p style={styles.bodyText}>
            We implement reasonable security practices as required by the <strong>IT (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011</strong> to protect your personal information from unauthorized access, disclosure, alteration, or destruction.
          </p>
          <p style={{ ...styles.bodyText, marginTop: 12 }}>Our security measures include:</p>
          <ul style={{ ...styles.bodyText, paddingLeft: 20, marginTop: 8 }}>
            <li style={{ marginBottom: 8 }}><strong>Encrypted passwords:</strong> All user passwords are hashed using industry-standard cryptographic algorithms (bcrypt). Plaintext passwords are never stored.</li>
            <li style={{ marginBottom: 8 }}><strong>HTTPS/TLS encryption:</strong> All data transmitted between your browser and our servers is encrypted using TLS (HTTPS).</li>
            <li style={{ marginBottom: 8 }}><strong>JWT-based authentication:</strong> Secure token-based session management to prevent unauthorized access.</li>
            <li style={{ marginBottom: 8 }}><strong>Cloudinary for images:</strong> All uploaded photographs are stored on Cloudinary's secure, encrypted cloud infrastructure with access controls.</li>
            <li style={{ marginBottom: 8 }}><strong>MongoDB Atlas:</strong> Our database is hosted on MongoDB Atlas with encryption at rest and in transit, role-based access control, and IP whitelisting.</li>
            <li style={{ marginBottom: 8 }}><strong>Access controls:</strong> Internal access to user data is restricted to authorized personnel only, on a need-to-know basis.</li>
          </ul>
          <p style={{ ...styles.bodyText, marginTop: 12 }}>
            While we take every reasonable precaution, no data transmission over the internet is 100% secure. You use the Platform at your own risk and are responsible for maintaining the security of your login credentials.
          </p>
        </div>

        {/* 5. Cookies */}
        <div style={styles.card} id="cookies">
          <h2 style={styles.sectionHeading}>5. Cookies</h2>
          <p style={styles.bodyText}>
            FraudCheck FDS uses cookies and similar tracking technologies to enhance your experience on the Platform. Cookies are small text files stored on your device.
          </p>
          <p style={{ ...styles.bodyText, marginTop: 12 }}>We use cookies for:</p>
          <ul style={{ ...styles.bodyText, paddingLeft: 20, marginTop: 8 }}>
            <li style={{ marginBottom: 8 }}><strong>Authentication:</strong> To keep you logged in securely during your session (via JWT tokens stored in localStorage/sessionStorage).</li>
            <li style={{ marginBottom: 8 }}><strong>Preferences:</strong> To remember your settings and preferences on the Platform.</li>
            <li style={{ marginBottom: 8 }}><strong>Analytics:</strong> To understand how users interact with the Platform and improve its functionality.</li>
          </ul>
          <p style={{ ...styles.bodyText, marginTop: 12 }}>
            You can control or disable cookies through your browser settings. However, disabling certain cookies may affect the functionality of the Platform. We do not use cookies for advertising or tracking across third-party websites.
          </p>
        </div>

        {/* 6. User Rights Under Indian Law */}
        <div style={styles.card} id="rights">
          <h2 style={styles.sectionHeading}>6. Your Rights Under Indian Law</h2>
          <p style={styles.bodyText}>
            As a data subject under the <strong>Information Technology Act, 2000</strong> and SPDI Rules 2011, you have the following rights regarding your personal information:
          </p>
          <ul style={{ ...styles.bodyText, paddingLeft: 20, marginTop: 10 }}>
            <li style={{ marginBottom: 8 }}>
              <strong>Right to Access:</strong> You may request a copy of the personal information we hold about you by contacting us at admin.umasankar@gmail.com.
            </li>
            <li style={{ marginBottom: 8 }}>
              <strong>Right to Correction:</strong> You may request correction of inaccurate or incomplete personal data through your account settings or by contacting us.
            </li>
            <li style={{ marginBottom: 8 }}>
              <strong>Right to Withdraw Consent:</strong> You may withdraw your consent to the processing of your personal data at any time. Note that withdrawal of consent may affect your ability to use the Platform's services.
            </li>
            <li style={{ marginBottom: 8 }}>
              <strong>Right to Grievance Redressal:</strong> You have the right to have your privacy-related grievances addressed within a reasonable timeframe. See Section 9 for our Grievance Officer details.
            </li>
            <li style={{ marginBottom: 8 }}>
              <strong>Right to Account Deletion:</strong> You may request deletion of your account and associated personal data by contacting us. Please note that fraud reports you have submitted may be retained in anonymized or de-identified form for the integrity of the fraud database.
            </li>
          </ul>
          <p style={{ ...styles.bodyText, marginTop: 12 }}>
            To exercise any of these rights, please contact our Grievance Officer as detailed in Section 9. We will respond to all verifiable requests within 30 days.
          </p>
        </div>

        {/* 7. Data Retention */}
        <div style={styles.card} id="retention">
          <h2 style={styles.sectionHeading}>7. Data Retention</h2>
          <p style={styles.bodyText}>
            We retain your personal information for as long as your account is active or as needed to provide you with our services. Specifically:
          </p>
          <ul style={{ ...styles.bodyText, paddingLeft: 20, marginTop: 10 }}>
            <li style={{ marginBottom: 8 }}><strong>Account data</strong> is retained for the duration of your account's existence plus up to 2 years after account closure for audit and legal compliance purposes.</li>
            <li style={{ marginBottom: 8 }}><strong>Fraud reports</strong> are retained indefinitely as they form the core fraud intelligence database. Individual report data may be anonymized or de-identified upon verified request from the reporting owner.</li>
            <li style={{ marginBottom: 8 }}><strong>Payment records</strong> are retained for 7 years in compliance with Indian financial regulations and tax laws.</li>
            <li style={{ marginBottom: 8 }}><strong>Activity logs</strong> are retained for up to 1 year for security and audit purposes.</li>
          </ul>
          <p style={{ ...styles.bodyText, marginTop: 12 }}>
            When data is no longer required and we have no legal obligation to retain it, we will securely delete or anonymize it.
          </p>
        </div>

        {/* 8. Children's Privacy */}
        <div style={styles.card} id="children">
          <h2 style={styles.sectionHeading}>8. Children's Privacy</h2>
          <p style={styles.bodyText}>
            FraudCheck FDS is a business-to-business (B2B) platform intended exclusively for adults who own or operate self-drive car rental businesses. Our platform is not directed to, and we do not knowingly collect personal information from, children under the age of 18.
          </p>
          <p style={{ ...styles.bodyText, marginTop: 12 }}>
            If you believe that a minor has provided us with personal information, please contact us immediately at admin.umasankar@gmail.com and we will take steps to delete such information from our records.
          </p>
        </div>

        {/* 9. Grievance Officer */}
        <div style={styles.card} id="grievance">
          <h2 style={styles.sectionHeading}>9. Grievance Officer</h2>
          <p style={styles.bodyText}>
            In accordance with the <strong>Information Technology Act, 2000</strong> and the <strong>IT (Intermediary Guidelines and Digital Media Ethics Code) Rules, 2021</strong>, we have designated a Grievance Officer to address any privacy-related concerns or complaints.
          </p>
          <div style={{ background: "#f4f7fe", borderRadius: 12, padding: "16px 20px", marginTop: 16, border: "1px solid #e5e7eb" }}>
            <p style={{ ...styles.bodyText, fontWeight: 700, color: "#1b2559", marginBottom: 8 }}>Grievance Officer — FraudCheck FDS</p>
            <p style={{ ...styles.bodyText, marginBottom: 6 }}>📧 Email: <a href="mailto:admin.umasankar@gmail.com" style={{ color: "#4318FF", fontWeight: 600 }}>admin.umasankar@gmail.com</a></p>
            <p style={{ ...styles.bodyText, marginBottom: 6 }}>📞 Phone: <a href="tel:7207270218" style={{ color: "#4318FF", fontWeight: 600 }}>7207270218</a></p>
            <p style={{ ...styles.bodyText, marginBottom: 6 }}>🌐 Website: <a href="https://fds.uvars.com" style={{ color: "#4318FF", fontWeight: 600 }}>fds.uvars.com</a></p>
            <p style={{ ...styles.bodyText, marginBottom: 0 }}>📍 Jurisdiction: Andhra Pradesh / Telangana, India</p>
          </div>
          <p style={{ ...styles.bodyText, marginTop: 12 }}>
            All privacy-related grievances or requests will be acknowledged within 48 hours and resolved within 30 days of receipt, wherever practicable.
          </p>
        </div>

        {/* 10. Changes */}
        <div style={styles.card} id="changes">
          <h2 style={styles.sectionHeading}>10. Changes to This Privacy Policy</h2>
          <p style={styles.bodyText}>
            We may update this Privacy Policy from time to time to reflect changes in our practices, technology, legal requirements, or other factors. When we make material changes, we will update the "Last Updated" date at the top of this page and notify registered users via email or in-platform notification where appropriate.
          </p>
          <p style={{ ...styles.bodyText, marginTop: 12 }}>
            Your continued use of the Platform after any modification to this Privacy Policy constitutes your acceptance of the updated policy. We encourage you to review this page periodically.
          </p>
        </div>

        {/* 11. Contact */}
        <div style={styles.card} id="contact">
          <h2 style={styles.sectionHeading}>11. Contact Us</h2>
          <p style={styles.bodyText}>
            If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact us:
          </p>
          <div style={{ marginTop: 16 }}>
            <p style={{ ...styles.bodyText, marginBottom: 8 }}><strong>Platform:</strong> FraudCheck FDS</p>
            <p style={{ ...styles.bodyText, marginBottom: 8 }}><strong>Website:</strong> <a href="https://fds.uvars.com" style={{ color: "#4318FF", fontWeight: 600 }}>fds.uvars.com</a></p>
            <p style={{ ...styles.bodyText, marginBottom: 8 }}><strong>Email:</strong> <a href="mailto:admin.umasankar@gmail.com" style={{ color: "#4318FF", fontWeight: 600 }}>admin.umasankar@gmail.com</a></p>
            <p style={{ ...styles.bodyText, marginBottom: 8 }}><strong>Phone:</strong> <a href="tel:7207270218" style={{ color: "#4318FF", fontWeight: 600 }}>7207270218</a></p>
            <p style={{ ...styles.bodyText, marginBottom: 0 }}><strong>Jurisdiction:</strong> Andhra Pradesh / Telangana, India</p>
          </div>
        </div>

      </div>

      <LegalFooter />
    </LegalLayout>
  );
};

export default PrivacyPolicy;
